'use client';

import { CircleX, Pause, Play } from 'lucide-react';
import type React from 'react';
import { useEffect } from 'react';

const ListenNow = ({ text, onClose }: { text: string; onClose: () => void }) => {
    const synth = window.speechSynthesis;
    const utterance = new SpeechSynthesisUtterance(text);
    const handlePlay = () => {
        synth.resume();
    };

    const handlePause = () => {
        synth.pause();
    };

    const handleClose = () => {
        synth.cancel(); // Stop the speech
        onClose(); // Call the onClose function to remove the component
    };
    useEffect(() => {
        // Set the voice to an Indian accent
        const voices = synth.getVoices();
        const indianVoice = voices.find((voice) => voice.lang.includes('en-IN'));
        if (indianVoice) {
            utterance.voice = indianVoice;
        }

        // Auto-play the text
        synth.speak(utterance);
        handlePlay();

        // Cleanup function to stop speech when component unmounts
        return () => {
            synth.cancel();
        };
    }, [text]);

    // Extract the first six words
    const truncatedText = text.split(' ').slice(0, 4).join(' ') + '...';
    return (
        <div className="fixed bottom-4 right-3 flex z-50 justify-center items-center p-2 mx-auto ml-6">
            <div className="bg-white rounded-lg shadow-md p-3 flex items-center w-full max-w-md border-[1px] border-solid border-[#B8B8B8] relative">
                <button
                    onClick={handleClose}
                    className="absolute -top-3 -right-2 text-gray-500 hover:text-gray-700 transition-colors bg-white rounded-2xl"
                    aria-label="Close"
                >
                    <CircleX />
                </button>
                <div className="flex-1">
                    <p
                        className="text-[#666666]"
                        style={{
                            fontFamily: 'Inter',
                            fontWeight: '400',
                            fontSize: '13px',
                            lineHeight: '20px',
                        }}
                    >
                        You are listening to
                    </p>
                    <h3
                        className="text-[#000000] truncate"
                        style={{
                            fontFamily: 'Inter',
                            fontWeight: '600',
                            fontSize: '13px',
                            lineHeight: '20px',
                        }}
                    >
                        {truncatedText}
                    </h3>
                </div>
                <div className="flex items-center space-x-2 ml-4">
                    <button
                        onClick={handlePlay}
                        className="w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center hover:bg-blue-600 transition-colors"
                        aria-label="Play"
                    >
                        <Play size={16} />
                    </button>
                    <button
                        onClick={handlePause}
                        className="w-8 h-8 rounded-full bg-gray-200 text-gray-700 flex items-center justify-center hover:bg-gray-300 transition-colors"
                        aria-label="Pause"
                    >
                        <Pause size={16} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ListenNow;
